import React from "react";
import { Reveal, Eyebrow } from "./Decorative";
import PosterFrame from "./PosterFrame";
import { InterestCta } from "./Bits";
import { LAST_EDITION } from "../lib/constants";

/**
 * Event-artwork block: the framed poster beside a short booking prompt.
 * Sits mid-page (below the fold) so the poster is never the mobile LCP.
 */
export default function PosterSection() {
  return (
    <section className="bg-[#0F0A07] py-24 md:py-32 px-6" data-testid="poster-section">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 md:gap-16 items-center">
        <Reveal>
          <PosterFrame maxW={380} />
        </Reveal>
        <Reveal delay={0.12}>
          <div className="text-center md:text-left">
            <Eyebrow>The evening</Eyebrow>
            <h2 className="mt-4 font-display text-4xl md:text-5xl leading-[1.05]" style={{ color: "#FBF6EE" }}>
              A Divine Bhajan<br /><span className="gold-grad italic">Jamming Experience</span>
            </h2>
            <p className="mt-5 font-body text-base md:text-lg leading-relaxed" style={{ color: "#E8D9C5" }}>
              {LAST_EDITION.dateLabel} · {LAST_EDITION.venue}, {LAST_EDITION.city}.
            </p>
            <div className="mt-8 flex md:block justify-center">
              <InterestCta tone="dark" className="md:items-start" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
